<template>
    <el-dialog :title="form.isNew ? '添加' : '编辑'" :visible.sync="dialogEdit" width="950px">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="margin-top: 20px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="导师姓名">
                        <el-input v-model="form.teacher_name" disabled class="inputwidth"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="学生姓名*" prop="student_name" label-width="150px">
                        <el-input v-model="form.student_name" class="inputwidth"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="项目类型*" prop="project_name">
                        <el-input v-model="form.project_name" class="inputwidth"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="金额*" prop="amount">
                        <el-input v-model="form.amount" class="inputwidth"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="日期" label-width="150px">
                        <el-input v-model="form.date" disabled class="inputwidth"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="备注*" prop="remark">
                        <el-input v-model="form.remark" class="inputwidth"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogEdit = false">取 消</el-button>
            <el-button type="primary" @click="putedit">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import axios from '../axios.js'
export default {
    name: 'miscellaneousDialog',
    props: {
        form: {}
    },
    data() {
        return {
            dialogEdit: false,
            rules: {
                student_name: [
                    {
                        required: true,
                        message: '请输入学生姓名'
                    }
                ],
                project_name: [
                    {
                        required: true,
                        message: '请输入项目类型'
                    }
                ],
                amount: [
                    {
                        required: true,
                        message: '请输入金额'
                    }
                ],
                remark: [
                    {
                        required: true,
                        message: '请输入备注'
                    }
                ]
            }
        }
    },
    methods: {
        openDialog() {
            this.dialogEdit = true
        },
        putedit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (this.form.isNew) {
                        // 新建记录
                        axios
                            .post(`/finance/miscellaneous/create`, {
                                teacher_id: this.form.teacher_id,
                                project_name: this.form.project_name,
                                student_name: this.form.student_name,
                                amount: this.form.amount,
                                remark: this.form.remark,
                                date: this.form.date
                            })
                            .then(res => {
                                if (res.status === 200) {
                                    this.$parent.getMiscellaneous()
                                    this.dialogEdit = false
                                    this.$message({
                                        message: '添加成功',
                                        type: 'success'
                                    })
                                }
                            })
                            .catch(err => {
                                this.$message({
                                    message: '添加失败: ' + (err.response?.data?.message || err.message),
                                    type: 'error'
                                })
                            })
                    } else {
                        // 编辑记录
                        axios
                            .put(`/finance/miscellaneous/${this.form.id}`, {
                                project_name: this.form.project_name,
                                student_name: this.form.student_name,
                                amount: this.form.amount,
                                remark: this.form.remark
                            })
                            .then(res => {
                                if (res.status === 200) {
                                    this.$parent.getMiscellaneous()
                                    this.dialogEdit = false
                                    this.$message({
                                        message: '修改成功',
                                        type: 'success'
                                    })
                                }
                            })
                            .catch(err => {
                                this.$message({
                                    message: '修改失败: ' + (err.response?.data?.message || err.message),
                                    type: 'error'
                                })
                            })
                    }
                }
            })
        }
    }
}
</script>

<style scoped>
.inputwidth {
    width: 135px;
}

.el-dialog__header {
    padding-left: 65px;
}

.el-dialog {
    padding-right: 30px;
}

.el-dialog__footer {
    padding-right: 50px;
}
</style>
